import React, {useState, useEffect} from 'react'
import {
  Box,
  Button,
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  Text,
  HStack,
} from '@chakra-ui/react'
import {HiLockClosed} from 'react-icons/hi'
import {BsCheck2, BsDot} from 'react-icons/bs'

const MaskedInput = ({
  inputTitle,
  isRequired,
  maxLength,
  type,
  toggleButton,
  showIcon,
  onChange,
  name,
  id,
  value,
  onPasswordValidationChange,
}) => {
  const [isMasked, setIsMasked] = useState(true)

  useEffect(() => {
    validatePassword()
  }, [value])

  const validatePassword = () => {
    const isValid =
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{10,}$/.test(value)

    if (onPasswordValidationChange) {
      onPasswordValidationChange(isValid)
    }
  }

  const formatNumbers = input => {
    const cleaned = input.replace(/\D/g, '')
    const isNumeric = /^\d+$/.test(cleaned)

    if (!isNumeric) {
      return ''
    }

    const match = cleaned.match(/^(\d{0,3})(\d{0,3})(\d{0,4})$/)

    let formattedNumber = ''
    if (match) {
      formattedNumber += match[1]
      formattedNumber += match[2]
      formattedNumber += match[3]
    }

    return formattedNumber
  }

  const formatSSN = input => {
    const cleaned = input.replace(/\D/g, '')
    const isNumeric = /^\d+$/.test(cleaned)

    if (!isNumeric) {
      return ''
    }

    let formattedNumber = ''

    if (cleaned.length <= 3) {
      formattedNumber += cleaned.slice(0, 3)
    } else if (cleaned.length <= 5) {
      formattedNumber += cleaned.slice(0, 3)
      formattedNumber += '-'
      formattedNumber += cleaned.slice(3, 5)
    } else {
      formattedNumber += cleaned.slice(0, 3)
      formattedNumber += '-'
      formattedNumber += cleaned.slice(3, 5)
      formattedNumber += '-'
      formattedNumber += cleaned.slice(5, 9)
    }

    return formattedNumber
  }

  const toggleMasking = () => {
    setIsMasked(!isMasked)
  }

  return (
    <Box>
      <Box mb={2}>
        <Text textStyle="b2">
          {inputTitle}
          {isRequired && (
            <Text as="span" color="sr60" ml={1}>
              *
            </Text>
          )}
        </Text>
      </Box>

      <InputGroup>
        {showIcon && (
          <InputLeftElement>
            {' '}
            <HiLockClosed />{' '}
          </InputLeftElement>
        )}
        <Input
          name={name}
          id={id}
          type={isMasked ? 'password' : 'text'}
          value={type === 'ssn' ? formatSSN(value) : value}
          onChange={onChange}
          maxLength={maxLength}
          borderColor="pg50"
          borderRadius=".25rem"
        />
        {toggleButton && (
          <InputRightElement>
            <Box mr={7}>
              <Button size="input" onClick={toggleMasking} fontWeight="500">
                {isMasked ? 'Show' : 'Hide'}
              </Button>
            </Box>
          </InputRightElement>
        )}
      </InputGroup>

      {type === 'password' && (
        <Box mt={5}>
          <Text textStyle="b3">Password requirements:</Text>
          <Box>
            <Text
              color={value.length >= 10 ? 'sg70' : 'pg60'}
              fontWeight={value.length >= 10 ? '500' : '300'}
            >
              <HStack mt={2}>
                <Box>{value.length >= 10 ? <BsCheck2 /> : <BsDot />}</Box>
                <Text>At least 10 characters long</Text>
              </HStack>
            </Text>

            <Text
              color={/[A-Z]/.test(value) ? 'sg70' : 'pg60'}
              fontWeight={/[A-Z]/.test(value) ? '500' : '300'}
            >
              <HStack>
                <Box>{/[A-Z]/.test(value) ? <BsCheck2 /> : <BsDot />}</Box>
                <Text>An uppercase letter</Text>
              </HStack>
            </Text>

            <Text
              color={/[a-z]/.test(value) ? 'sg70' : 'pg60'}
              fontWeight={/[a-z]/.test(value) ? '500' : '300'}
            >
              <HStack>
                <Box>{/[a-z]/.test(value) ? <BsCheck2 /> : <BsDot />}</Box>
                <Text>A lowercase letter</Text>
              </HStack>
            </Text>

            <Text
              color={/[0-9]/.test(value) ? 'sg70' : 'pg60'}
              fontWeight={/[0-9]/.test(value) ? '500' : '300'}
            >
              <HStack>
                <Box>{/[0-9]/.test(value) ? <BsCheck2 /> : <BsDot />}</Box>
                <Text>A number</Text>
              </HStack>
            </Text>

            <Text
              color={/[^A-Za-z0-9]/.test(value) ? 'sg70' : 'pg60'}
              fontWeight={/[^A-Za-z0-9]/.test(value) ? '500' : '300'}
            >
              <HStack>
                <Box>
                  {/[^A-Za-z0-9]/.test(value) ? <BsCheck2 /> : <BsDot />}
                </Box>
                <Text>A special character</Text>
              </HStack>
            </Text>
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default MaskedInput
